var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDealSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8869_5572)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.06762 2.33298L6.58817 0.812458C6.81596 0.584649 7.18527 0.584649 7.41312 0.812458L8.93363 2.33298H11.084C11.4061 2.33298 11.6673 2.59415 11.6673 2.91631V5.06664L13.1878 6.58718C13.4156 6.81497 13.4156 7.18434 13.1878 7.41213L11.6673 8.93264V11.083C11.6673 11.4052 11.4061 11.6663 11.084 11.6663H8.93363L7.41312 13.1868C7.18527 13.4146 6.81596 13.4146 6.58817 13.1868L5.06762 11.6663H2.91728C2.59512 11.6663 2.33395 11.4052 2.33395 11.083V8.93264L0.813435 7.41213C0.585626 7.18434 0.585626 6.81497 0.813435 6.58718L2.33395 5.06664V2.91631C2.33395 2.59415 2.59512 2.33298 2.91728 2.33298H5.06762ZM3.50062 3.49964V5.5499L2.05087 6.99965L3.50062 8.44941V10.4997H5.55087L7.00064 11.9494L8.45034 10.4997H10.5006V8.44941L11.9503 6.99965L10.5006 5.5499V3.49964H8.45034L7.00064 2.0499L5.55087 3.49964H3.50062ZM7.00064 9.33299C5.71195 9.33299 4.66728 8.2883 4.66728 6.99965C4.66728 5.71098 5.71195 4.66631 7.00064 4.66631C8.28928 4.66631 9.33397 5.71098 9.33397 6.99965C9.33397 8.2883 8.28928 9.33299 7.00064 9.33299ZM7.00064 8.16632C7.64493 8.16632 8.16731 7.644 8.16731 6.99965C8.16731 6.3553 7.64493 5.83299 7.00064 5.83299C6.35629 5.83299 5.83397 6.3553 5.83397 6.99965C5.83397 7.644 6.35629 8.16632 7.00064 8.16632Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8869_5572"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDealSettings);
export default __webpack_public_path__ + "static/media/deal-settings.6a907c9b6ac3348a23f730414cdaf8a4.svg";
export { ForwardRef as ReactComponent };